import request from '../../../helpers/request';

const deleteRoomAttachment = async (attachmentId, room) => {
  await request.put(
    `/RentPlace/rental_house/office`,
    {
      ...room,
      attachments: room.attachments.filter(
        (attachment) => attachment.id !== attachmentId
      ),
    },
    'Произошла ошибка при удалении файла'
  );
};

export default deleteRoomAttachment;
